export default function ImageViewer(props) {
  if (props.xs) return <img {...props} src={`https://ik.imagekit.io/1thczwpod/${props.image}?tr=w-50`} />
  if (props.small) return <img {...props} src={`https://ik.imagekit.io/1thczwpod/${props.image}?tr=w-200`} />
  return <img {...props} src={`https://ik.imagekit.io/1thczwpod/${props.image}`} />
}